export const routeOptions = [
  {
    isBefore6: null,
    assemblyPoint: "Green Assembly",
    assemblyCoordinates: [-33.8291667, 151.2094444],
    viaPoints: [
      {
        latitude: -33.825407548,
        longitude: 151.19974855,
      },
      {
        latitude: -33.826083782,
        longitude: 151.200331021,
      },
      {
        latitude: -33.826148593,
        longitude: 151.200387071,
      },
      {
        latitude: -33.826187701,
        longitude: 151.20076758,
      },
      {
        latitude: -33.826414498,
        longitude: 151.200763664,
      },
      {
        latitude: -33.827487796,
        longitude: 151.200778839,
      },
      {
        latitude: -33.827585996,
        longitude: 151.200897665,
      },
      {
        latitude: -33.828118066,
        longitude: 151.204354487,
      },
      {
        latitude: -33.828471288,
        longitude: 151.206260282,
      },
      {
        latitude: -33.828471296,
        longitude: 151.206593973,
      },
      {
        latitude: -33.828551695,
        longitude: 151.207092468,
      },
      {
        latitude: -33.828836566,
        longitude: 151.208844401,
      },
      {
        latitude: -33.828997237,
        longitude: 151.208854259,
      },
      {
        latitude: -33.829062098,
        longitude: 151.208991052,
      },
      {
        latitude: -33.8291229,
        longitude: 151.209196314,
      },
      {
        latitude: -33.829172643,
        longitude: 151.209514962,
      },
      {
        latitude: -33.82935485,
        longitude: 151.20950667,
      },
      {
        latitude: -33.829488921,
        longitude: 151.209496592,
      },
    ],
    point_count: 18,
  },
  {
    isBefore6: true,
    assemblyPoint: "Red Assembly",
    assemblyCoordinates: [-33.8311111, 151.2102778],
    viaPoints: [
      {
        latitude: -33.84104329,
        longitude: 151.207800871,
      },
      {
        latitude: -33.841013364,
        longitude: 151.207841891,
      },
      {
        latitude: -33.84106893,
        longitude: 151.208341629,
      },
      {
        latitude: -33.840987697,
        longitude: 151.208422635,
      },
      {
        latitude: -33.840917349,
        longitude: 151.208440317,
      },
      {
        latitude: -33.840847,
        longitude: 151.208458,
      },
      {
        latitude: -33.84083003,
        longitude: 151.208469091,
      },
      {
        latitude: -33.84081306,
        longitude: 151.208480181,
      },
      {
        latitude: -33.840545136,
        longitude: 151.20853588,
      },
      {
        latitude: -33.840277211,
        longitude: 151.208591578,
      },
      {
        latitude: -33.839682,
        longitude: 151.208711,
      },
      {
        latitude: -33.838357271,
        longitude: 151.208966712,
      },
      {
        latitude: -33.837066074,
        longitude: 151.209141843,
      },
      {
        latitude: -33.833388839,
        longitude: 151.209925274,
      },
      {
        latitude: -33.833225702,
        longitude: 151.210161927,
      },
      {
        latitude: -33.833234389,
        longitude: 151.21028021,
      },
      {
        latitude: -33.833243075,
        longitude: 151.210398492,
      },
      {
        latitude: -33.833243112,
        longitude: 151.210575292,
      },
      {
        latitude: -33.833243148,
        longitude: 151.210752091,
      },
      {
        latitude: -33.832925961,
        longitude: 151.210813766,
      },
      {
        latitude: -33.83264339,
        longitude: 151.210886752,
      },
      {
        latitude: -33.832517977,
        longitude: 151.210980775,
      },
      {
        latitude: -33.832383417,
        longitude: 151.21115522,
      },
      {
        latitude: -33.832034929,
        longitude: 151.211442361,
      },
      {
        latitude: -33.831777418,
        longitude: 151.211598922,
      },
      {
        latitude: -33.831648823,
        longitude: 151.211397292,
      },
      {
        latitude: -33.831512424,
        longitude: 151.211101717,
      },
      {
        latitude: -33.83135575,
        longitude: 151.211033832,
      },
      {
        latitude: -33.831264149,
        longitude: 151.210855345,
      },
      {
        latitude: -33.831227264,
        longitude: 151.210538141,
      },
      {
        latitude: -33.831065678,
        longitude: 151.210534692,
      },
    ],
    point_count: 31,
  },
  {
    isBefore6: false,
    assemblyPoint: "Red Assembly",
    assemblyCoordinates: [-33.8311111, 151.2102778],
    viaPoints: [
      {
        latitude: -33.836712377,
        longitude: 151.208741588,
      },
      {
        latitude: -33.836678626,
        longitude: 151.208730955,
      },
      {
        latitude: -33.835623725,
        longitude: 151.208974882,
      },
      {
        latitude: -33.835013216,
        longitude: 151.209066599,
      },
      {
        latitude: -33.835083586,
        longitude: 151.209543418,
      },
      {
        latitude: -33.833384902,
        longitude: 151.209957174,
      },
      {
        latitude: -33.833254932,
        longitude: 151.210056457,
      },
      {
        latitude: -33.833237443,
        longitude: 151.210094517,
      },
      {
        latitude: -33.833219954,
        longitude: 151.210132576,
      },
      {
        latitude: -33.833215607,
        longitude: 151.210314706,
      },
      {
        latitude: -33.833211259,
        longitude: 151.210496836,
      },
      {
        latitude: -33.833255074,
        longitude: 151.210745094,
      },
      {
        latitude: -33.832677807,
        longitude: 151.21090027,
      },
      {
        latitude: -33.832581835,
        longitude: 151.210916323,
      },
      {
        latitude: -33.832485871,
        longitude: 151.211032158,
      },
      {
        latitude: -33.832377992,
        longitude: 151.211166618,
      },
      {
        latitude: -33.831984013,
        longitude: 151.211475548,
      },
      {
        latitude: -33.831771612,
        longitude: 151.211593924,
      },
      {
        latitude: -33.831607524,
        longitude: 151.21131597,
      },
      {
        latitude: -33.831506447,
        longitude: 151.211107937,
      },
      {
        latitude: -33.831349671,
        longitude: 151.211034308,
      },
      {
        latitude: -33.831276415,
        longitude: 151.210860305,
      },
      {
        latitude: -33.831227264,
        longitude: 151.210538141,
      },
      {
        latitude: -33.831040571,
        longitude: 151.210535963,
      },
    ],
    point_count: 26,
  },
  {
    isBefore6: false,
    assemblyPoint: "Red Assembly",
    assemblyCoordinates: [-33.8311111, 151.2102778],
    viaPoints: [
      {
        latitude: -33.841058853,
        longitude: 151.207685487,
      },
      {
        latitude: -33.840047404,
        longitude: 151.207252325,
      },
      {
        latitude: -33.839192477,
        longitude: 151.20696989,
      },
      {
        latitude: -33.838739045,
        longitude: 151.207080281,
      },
      {
        latitude: -33.836786319,
        longitude: 151.207413222,
      },
      {
        latitude: -33.836954901,
        longitude: 151.208694264,
      },
      {
        latitude: -33.835050661,
        longitude: 151.209072767,
      },
      {
        latitude: -33.835081542,
        longitude: 151.209544819,
      },
      {
        latitude: -33.833376116,
        longitude: 151.209936794,
      },
      {
        latitude: -33.833253602,
        longitude: 151.210077904,
      },
      {
        latitude: -33.833212385,
        longitude: 151.210226512,
      },
      {
        latitude: -33.833261949,
        longitude: 151.21074462,
      },
      {
        latitude: -33.832630932,
        longitude: 151.210928371,
      },
      {
        latitude: -33.832507288,
        longitude: 151.211003298,
      },
      {
        latitude: -33.832345367,
        longitude: 151.21121876,
      },
      {
        latitude: -33.83177742,
        longitude: 151.211576353,
      },
      {
        latitude: -33.831713349,
        longitude: 151.211464489,
      },
      {
        latitude: -33.831530333,
        longitude: 151.211094519,
      },
      {
        latitude: -33.831349672,
        longitude: 151.211005432,
      },
      {
        latitude: -33.831264149,
        longitude: 151.210855345,
      },
      {
        latitude: -33.83124573,
        longitude: 151.210554617,
      },
      {
        latitude: -33.831053134,
        longitude: 151.210517725,
      },
    ],
    point_count: 22,
  },
  {
    isBefore6: true,
    assemblyPoint: "Orange Assembly",
    assemblyCoordinates: [-33.8325, 151.21],
    viaPoints: [
      {
        latitude: -33.84104329,
        longitude: 151.207800871,
      },
      {
        latitude: -33.841013364,
        longitude: 151.207841891,
      },
      {
        latitude: -33.84106893,
        longitude: 151.208341629,
      },
      {
        latitude: -33.840987697,
        longitude: 151.208422635,
      },
      {
        latitude: -33.84081306,
        longitude: 151.208480181,
      },
      {
        latitude: -33.840277211,
        longitude: 151.208591578,
      },
      {
        latitude: -33.839682,
        longitude: 151.208711,
      },
      {
        latitude: -33.838357271,
        longitude: 151.208966712,
      },
      {
        latitude: -33.837066074,
        longitude: 151.209141843,
      },
      {
        latitude: -33.833388839,
        longitude: 151.209925274,
      },
      {
        latitude: -33.833225702,
        longitude: 151.210161927,
      },
      {
        latitude: -33.833243075,
        longitude: 151.210398492,
      },
      {
        latitude: -33.833243148,
        longitude: 151.210752091,
      },
      {
        latitude: -33.832925961,
        longitude: 151.210813766,
      },
      {
        latitude: -33.83264339,
        longitude: 151.210886752,
      },
      {
        latitude: -33.832390774,
        longitude: 151.21038728,
      },
      {
        latitude: -33.832439882,
        longitude: 151.210255859,
      },
      {
        latitude: -33.832649525,
        longitude: 151.210165839,
      },
    ],
    point_count: 18,
  },
  {
    isBefore6: false,
    assemblyPoint: "Orange Assembly",
    assemblyCoordinates: [-33.8325, 151.21],
    viaPoints: [
      {
        latitude: -33.836712377,
        longitude: 151.208741588,
      },
      {
        latitude: -33.836678626,
        longitude: 151.208730955,
      },
      {
        latitude: -33.835623725,
        longitude: 151.208974882,
      },
      {
        latitude: -33.835013216,
        longitude: 151.209066599,
      },
      {
        latitude: -33.835083586,
        longitude: 151.209543418,
      },
      {
        latitude: -33.833384902,
        longitude: 151.209957174,
      },
      {
        latitude: -33.833254932,
        longitude: 151.210056457,
      },
      {
        latitude: -33.833219954,
        longitude: 151.210132576,
      },
      {
        latitude: -33.833211259,
        longitude: 151.210496836,
      },
      {
        latitude: -33.833255074,
        longitude: 151.210745094,
      },
      {
        latitude: -33.832677807,
        longitude: 151.21090027,
      },
      {
        latitude: -33.832374067,
        longitude: 151.210362384,
      },
      {
        latitude: -33.832492865,
        longitude: 151.21019614,
      },
      {
        latitude: -33.83264096,
        longitude: 151.210143035,
      },
    ],
    point_count: 14,
  },
  {
    isBefore6: false,
    assemblyPoint: "Orange Assembly",
    assemblyCoordinates: [-33.8325, 151.21],
    viaPoints: [
      {
        latitude: -33.841058853,
        longitude: 151.207685487,
      },
      {
        latitude: -33.840047404,
        longitude: 151.207252325,
      },
      {
        latitude: -33.839192477,
        longitude: 151.20696989,
      },
      {
        latitude: -33.838739045,
        longitude: 151.207080281,
      },
      {
        latitude: -33.836786319,
        longitude: 151.207413222,
      },
      {
        latitude: -33.836954901,
        longitude: 151.208694264,
      },
      {
        latitude: -33.835050661,
        longitude: 151.209072767,
      },
      {
        latitude: -33.835081542,
        longitude: 151.209544819,
      },
      {
        latitude: -33.833376116,
        longitude: 151.209936794,
      },
      {
        latitude: -33.833253602,
        longitude: 151.210077904,
      },
      {
        latitude: -33.833212385,
        longitude: 151.210226512,
      },
      {
        latitude: -33.833261949,
        longitude: 151.21074462,
      },
      {
        latitude: -33.832630932,
        longitude: 151.210928371,
      },
      {
        latitude: -33.83237961,
        longitude: 151.21042968,
      },
      {
        latitude: -33.832379588,
        longitude: 151.21031127,
      },
      {
        latitude: -33.832586447,
        longitude: 151.210148341,
      },
    ],
    point_count: 16,
  },
];
